export const SHOW_OFFLINE_VIEW = "SHOW_OFFLINE_VIEW";

export const HIDE_OFFLINE_VIEW = "HIDE_OFFLINE_VIEW";
